Wee.fn.make('formFilter', {
	filter: function(conf) {
		var $el = $(conf.el),
			formData = $(conf.form).serialize(true),
			obj = {};

		for (var item in formData) {
			if (formData.hasOwnProperty(item) && formData[item] !== '') {
				obj[item] = formData[item];
			}
		}

		$.history.go({
			path: conf.path + '?' + $.serialize(obj),
			request: {
				complete: function() {
					$el.siblings('ref:newsFilter').toggle();
				}
			}
		});
	}
});
